<app-header class="app-header" [small]="isMap" *ngIf="isHeaderVisible"></app-header>
<div class="app-body" [class._unmargin]="isMap">
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="headerFooterVisibilityService.isFooterVisible$ | async"></app-footer>
